import { featureFlagActions } from './feature-flag-actions';
class FeatureFlagsHelper {
  initialise(dispatch): void {
    const flagKeyMap = {
      addViewWorkshopsCtaToBurgerMenu: true,
      autinoConnectIntegration: false,
      bookingManagement: true,
      clickablePills: true,
      'consumer-video-new-placement': false,
      consumerTestimonials: true,
      'demo-ab-testing-flag': false,
      enhancementsToConsumerHeaderMenu: true,
      'experimentation-pre-requisite-flag': 'Experiment 1',
      flagUsedDuringFirstDemo: false,
      hideLocationOnHomePage: false,
      homepageUpdateTextWithBrandPromise: true,
      howCaramaWorks: false,
      'location-filter-on-home-page': true,
      makeAppointmentCtaSticky: true,
      removeTitleFields: true,
      'show-mobile-number-input-field': false,
      specializationsOnWorkshopCards: true,
      'stop-getting-profile-when-logged-out': false,
      useYoutubeForHomepageVideo: true,
      workshopSorting: true,
    };
    dispatch(featureFlagActions.featureFlags(flagKeyMap));
  }
}
const featureFlagsHelper = new FeatureFlagsHelper();
export default featureFlagsHelper;
